import { forwardRef, useContext } from 'react'
import { ChipsIconContainer } from '../styled-components'
import { ChipsContext } from './chips-context'

const ChipsIcon = forwardRef(({ children, ...props }, fowardedRef) => {
  const context = useContext(ChipsContext)

  return (
    <ChipsIconContainer ref={fowardedRef} {...props} {...context}>
      {children}
    </ChipsIconContainer>
  )
})

ChipsIcon.displayName = 'ChipsIcon'

export default ChipsIcon
